/**
 * External URLs for VoteMate application
 */
export const EXTERNAL_URLS = {
  VOTEMATE_WEBSITE: 'https://votemate.io',
  VOTEMATE_ORG: 'https://www.votemateus.org/',
  TERMS_OF_USE: 'https://votemateus.org/terms',
  PRIVACY_POLICY: 'https://votemateus.org/privacy',
  RESPONSIBLE_AI: 'https://votemateus.org/transparency',
  APP_STORE: 'https://apps.apple.com/us/app/votemate-ai-ballot-assistant/id6773528182',
  PLAY_STORE: 'https://play.google.com/store/apps/details?id=com.votemateus.app',
  // Fallback while a build has no Stripe publishable key (see useOpenMembership).
  DONATE: 'https://www.zeffy.com/en-US/donation-form/built-by-voters-for-voters',
} as const;

/**
 * Internal application routes
 */
export const INTERNAL_ROUTES = {
  HOME: '/',
  CHAT: '/chat',
  HELP: '/help',
  SETTINGS: '/settings',
  MEMBERSHIP: '/membership',
} as const;

/**
 * Helper function to open external URL in new tab
 */
export const openExternalUrl = (url: string): void => {
  window.open(url, '_blank', 'noopener,noreferrer');
};
